import { jwtDecode } from 'jwt-decode';
//
import axios from './axios';

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) return false;
  try {
    const { exp } = jwtDecode(accessToken);
    return Date.now() < exp * 1000;
  } catch (error) {
    return false;
  }
};

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};
